// Généré par maquettes/outils/dc2react.py.
import React from 'react';
import SiteHeader from './sections/SiteHeader';
import Hero from './sections/Hero';
import Equipes from './sections/Equipes';
import Canaux from './sections/Canaux';
import Systeme from './sections/Systeme';
import APropos from './sections/APropos';
import References from './sections/References';
import Offres from './sections/Offres';
import Methode from './sections/Methode';
import Faq from './sections/Faq';
import Contact from './sections/Contact';
import SiteFooter from './sections/SiteFooter';

export default function HomeView({ v }) {
  return (
    <div style={{ background: "#FBFBFA", color: "#15171A", fontFamily: "'Archivo', 'Helvetica Neue', Helvetica, sans-serif", fontSize: "17px", lineHeight: "1.5" }}>
      <SiteHeader v={v} />
      <Hero v={v} />
      <Equipes v={v} />
      <Canaux v={v} />
      <Systeme v={v} />
      <APropos v={v} />
      <References v={v} />
      <Offres v={v} />
      <Methode v={v} />
      <Faq v={v} />
      <Contact v={v} />
      <SiteFooter v={v} />
    </div>
  );
}
